import React, { Component } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import { Card, CardHeader, CardBody, FormGroup, Label, Input, Button } from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getFormValues, change } from 'redux-form';
import * as submissionFormActions from 'actions/submissionFormActions';
import * as currentUserActions from 'actions/currentUserActions';
import * as snapSellWizardActions from 'actions/snapSellWizardActions';
import actionTypes from 'constants/currentUserConstants';

const emailValidator = value =>
  value && /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)

class EmailSnapSellForm extends Component {
  static propTypes = {
    currentUser: ImmutablePropTypes.map.isRequired,
    submitForm: PropTypes.func.isRequired,
    formValues: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    checkEmail: PropTypes.func.isRequired,
    formIsLoading: PropTypes.bool.isRequired,
  };

  state = {
    emailValid: true,
  };

  onEmailChange = (e) => {
    let email = e.target.value;
    if (email) email = email.toLowerCase();

    this.props.dispatch({ type: actionTypes.EMAIL_CHANGED });
    this.props.dispatch(change('eventSubmission', 'email', email));
  };

  onSubmit = (event) => {
    event.preventDefault();
    const { formValues: { email } } = this.props;
    const valid = emailValidator(email);
    this.setState({ emailValid: valid });
    if (!valid) return;
    window.history.pushState({}, '', window.location.href);
    this.props.checkEmail(email);
  };

  onBack = () => this.props.goToPreviousSnapSellStep();

  renderPackageBlock() {
    const { packageType, eventQuantity, currentPrice } = this.props;
    if (packageType === 'free') {
      return <p>Free Package</p>
    }

    if (packageType === 'single') {
      return <p>One Off Package - ${currentPrice} to promote 1 event</p>
    }

    return <p>Subscription Package - ${currentPrice} to promote {eventQuantity} events each month</p>
  }

  render() {
    const { formValues, currentUser, formIsLoading, partnerExports } = this.props;
    const isLoading = formIsLoading || currentUser.get('isLoading');
    const features = partnerExports ? partnerExports.toJS() : {};

    return (
      <Card>
        <CardHeader>
          <h3>Complete your purchase</h3>
        </CardHeader>
        <CardBody>
          {this.renderPackageBlock()}

          <h3>Products</h3>
          <ul>
            <li>Featured Online</li>
            <li>Syndicated</li>
            {features.print && <li>Print</li>}
            {features.voice && <li>Voice</li>}
          </ul>

          <h3>Features</h3>
          <ul>
            <li>Analytics Reporting</li>
            <li>Unlimited Edits</li>
            <li>Click Tracking</li>
            <li>SEO</li>
          </ul>

          <form onSubmit={this.onSubmit}>
            <fieldset>
              <FormGroup>
                <Label>Insert your email</Label>
                <Input
                  type="email"
                  placeholder="Your Email"
                  autoCapitalize="none"
                  autoCorrect="false"
                  value={formValues.email || ''}
                  onChange={this.onEmailChange}
                />
                {!this.state.emailValid && <p className="text-danger">Please enter a valid email address</p>}
              </FormGroup>
              <Button disabled={isLoading} block color="primary">
                {isLoading ? 'Please wait...' : 'Continue'}
              </Button>
            </fieldset>
          </form>
        </CardBody>
        <Button onClick={this.onBack} color="link">Previous Step</Button>
      </Card>
    );
  }
}

const mapStateToProps = (state) => ({
  formIsLoading: state.submissionForm.get('isLoading'),
  formValues: getFormValues('eventSubmission')(state),
  currentUser: state.currentUser,
  packageType: state.checkoutData.get('package_type'),
  eventQuantity: state.checkoutData.get('event_quantity'),
  currentPrice: state.checkoutData.get('currentPrice'),
  partnerExports: state.checkoutData.get('partner_exports'),
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  ...bindActionCreators(submissionFormActions, dispatch),
  ...bindActionCreators(currentUserActions, dispatch),
  ...bindActionCreators(snapSellWizardActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EmailSnapSellForm);



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/forms/final/EmailSnapSellForm.jsx